(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["teknik-bilgi-merkezi"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function normalizeText(value) {
    var text = String(value || '').toLocaleLowerCase('tr-TR');

    if (typeof text.normalize === 'function') {
      text = text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    }

    return text
      .replace(/ı/g, 'i')
      .replace(/ş/g, 's')
      .replace(/ğ/g, 'g')
      .replace(/ü/g, 'u')
      .replace(/ö/g, 'o')
      .replace(/ç/g, 'c')
      .trim();
  }

  function setHidden(element, hidden) {
    if (!element) return;
    element.classList.toggle('kuv-help-is-hidden', hidden);
    element.setAttribute('aria-hidden', hidden ? 'true' : 'false');
  }

  function initHelpCenter(root) {
    if (!root || root.getAttribute('data-kuv-help-ready') === 'true') return;

    var searchInput = root.querySelector('#KuvHelpSearch');
    var clearButton = root.querySelector('.kuv-help__search-clear');
    var filterButtons = Array.prototype.slice.call(root.querySelectorAll('[data-filter]'));
    var faqItems = Array.prototype.slice.call(root.querySelectorAll('.kuv-help__faq-item'));
    var groups = Array.prototype.slice.call(root.querySelectorAll('.kuv-help__faq-group'));
    var resultCount = root.querySelector('[data-result-count]');
    var noResults = root.querySelector('.kuv-help__no-results');
    var resetButton = root.querySelector('[data-reset-search]');
    var categoryJumps = Array.prototype.slice.call(root.querySelectorAll('[data-category-jump]'));
    var guideTabs = Array.prototype.slice.call(root.querySelectorAll('[data-guide-tab]'));
    var popularLinks = Array.prototype.slice.call(root.querySelectorAll('.kuv-help__popular a'));
    var faqSection = root.querySelector('#tum-sorular');
    var activeFilter = 'all';

    if (!searchInput || !faqItems.length) return;
    root.setAttribute('data-kuv-help-ready', 'true');

    function updateActiveFilterButtons() {
      filterButtons.forEach(function (button) {
        button.classList.toggle('is-active', button.getAttribute('data-filter') === activeFilter);
      });
    }

    function applyFilters(options) {
      options = options || {};
      var query = normalizeText(searchInput.value);
      var visibleCount = 0;

      faqItems.forEach(function (item) {
        var category = item.getAttribute('data-category') || '';
        var content = normalizeText(item.getAttribute('data-search') || item.textContent);
        var categoryMatch = activeFilter === 'all' || category === activeFilter;
        var searchMatch = !query || content.indexOf(query) !== -1;
        var shouldShow = categoryMatch && searchMatch;

        setHidden(item, !shouldShow);

        if (shouldShow) {
          visibleCount += 1;
          if (query.length >= 3) item.open = true;
        } else if (query) {
          item.open = false;
        }
      });

      groups.forEach(function (group) {
        var items = Array.prototype.slice.call(group.querySelectorAll('.kuv-help__faq-item'));
        var hasVisibleItem = items.some(function (item) {
          return !item.classList.contains('kuv-help-is-hidden');
        });
        setHidden(group, !hasVisibleItem);
      });

      if (resultCount) resultCount.textContent = String(visibleCount);
      setHidden(noResults, visibleCount !== 0);

      if (options.scrollToResults && faqSection) {
        faqSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    searchInput.addEventListener('input', function () {
      activeFilter = 'all';
      updateActiveFilterButtons();
      applyFilters();
    });

    searchInput.addEventListener('search', function () {
      applyFilters();
    });

    if (clearButton) {
      clearButton.addEventListener('click', function () {
        searchInput.value = '';
        activeFilter = 'all';
        updateActiveFilterButtons();
        applyFilters();
        searchInput.focus();
      });
    }

    if (resetButton) {
      resetButton.addEventListener('click', function () {
        searchInput.value = '';
        activeFilter = 'all';
        updateActiveFilterButtons();
        applyFilters();
        searchInput.focus();
      });
    }

    filterButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        activeFilter = button.getAttribute('data-filter') || 'all';
        updateActiveFilterButtons();
        applyFilters({ scrollToResults: true });
      });
    });

    categoryJumps.forEach(function (link) {
      link.addEventListener('click', function () {
        activeFilter = link.getAttribute('data-category-jump') || 'all';
        searchInput.value = '';
        updateActiveFilterButtons();
        applyFilters();
      });
    });

    guideTabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var target = tab.getAttribute('data-guide-tab');

        guideTabs.forEach(function (item) {
          item.classList.toggle('is-active', item === tab);
        });

        root.querySelectorAll('[data-guide-panel]').forEach(function (panel) {
          panel.classList.toggle('is-active', panel.getAttribute('data-guide-panel') === target);
        });
      });
    });

    popularLinks.forEach(function (link) {
      link.addEventListener('click', function () {
        activeFilter = 'all';
        searchInput.value = '';
        updateActiveFilterButtons();
        applyFilters();

        window.setTimeout(function () {
          var selector = link.getAttribute('href');
          var target = selector ? root.querySelector(selector) : null;
          if (target) {
            setHidden(target, false);
            target.open = true;
            target.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        }, 20);
      });
    });

    applyFilters();
  }

  function initAll(scope) {
    var container = scope || document;

    if (container.matches && container.matches('[data-kuv-help]')) {
      initHelpCenter(container);
    }

    if (container.querySelectorAll) {
      container.querySelectorAll('[data-kuv-help]').forEach(initHelpCenter);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
